import 'isomorphic-fetch';
import Application from './components/Application';
import {BrowserRouter} from 'react-router-dom';
import React from 'react';
import {hydrateRoot} from 'react-dom/client';
import {RelayEnvironmentProvider} from 'react-relay/hooks';
import createRelayEnvironment from './createRelayEnvironment';
import Cookies from 'js-cookie';
import {SubscriptionStateProvider} from './components/SubscriptionState';
import {WdlProvider} from './components/wdl';
import {AuthorizationProvider} from './contexts/Authorization'
import {CartProvider} from './contexts/cart';
import {InstantProvider} from './contexts/instant';
import CheckoutProvider from './components/CheckoutProvider';
import DialogProvider from './components/DialogProvider';
import {HelmetProvider} from 'react-helmet-async';
import {MoveProvider} from './components/Move';
import {ScanSettingsProvider} from './pages/scan/settings-context';
import {ScrollProvider} from './contexts/scroll';
import {ContractProvider} from './contexts/contract';

const encodeUtmHeader = (value) => (value == null ? value : encodeURIComponent(value));

const store = {
    get: function(key) {return Cookies.get(key);},
    set: function(key, value) {Cookies.set(key, value, {expires: 365, path: '/'});},
    remove: function(key) {Cookies.remove(key, {path: '/'});},
    getRequestUrl: function() {return window.location.pathname}
};

hydrateRoot(document.getElementById('root'),
    <RelayEnvironmentProvider environment={createRelayEnvironment(
        () => {
                let headers = {'Content-Type': 'application/json'};
                const urlParams = new URLSearchParams(window.location.search);
                const utm_source = urlParams.get('utm_source');
                const utm_medium = urlParams.get('utm_medium');
                const utm_campaign = urlParams.get('utm_campaign');
                if (window?.CookieConsentApi?.allowedCategory('analytics') && Cookies.get('_fbp')) {
                    headers = {...headers, 'Fbp': Cookies.get('_fbp')};
                }
                if (window?.CookieConsentApi?.allowedCategory('analytics') && Cookies.get('_fbc')) {
                    headers = {...headers, 'Fbc': Cookies.get('_fbc')};
                }
                if (utm_source) {
                    headers = {...headers, 'Utm-Source': encodeUtmHeader(utm_source)};
                }
                if (utm_medium) {
                    headers = {...headers, 'Utm-Medium': encodeUtmHeader(utm_medium)};
                }
                if (utm_campaign) {
                    headers = {...headers, 'Utm-Campaign': encodeUtmHeader(utm_campaign)};
                }
                return headers;
            }, store
    )}>
        <BrowserRouter>
            <HelmetProvider>
                <WdlProvider>
                    <AuthorizationProvider {...{store}}>
                        <SubscriptionStateProvider>
                            <MoveProvider>
                                <CartProvider>
                                    <InstantProvider>
                                        <CheckoutProvider>
                                            <DialogProvider>
                                                <ScanSettingsProvider>
                                                    <ScrollProvider>
                                                        <ContractProvider {...{store}}>
                                                            <Application/>
                                                        </ContractProvider>
                                                    </ScrollProvider>
                                                </ScanSettingsProvider>
                                            </DialogProvider>
                                        </CheckoutProvider>
                                    </InstantProvider>
                                </CartProvider>
                            </MoveProvider>
                        </SubscriptionStateProvider>
                    </AuthorizationProvider>
                </WdlProvider>
            </HelmetProvider>
        </BrowserRouter>
    </RelayEnvironmentProvider>
);

if (module.hot) {
    module.hot.accept();
}
